import { css } from 'styled-components'
import { useMemo } from 'use-memo-one'

import { AppDataTable } from '@root/features/app-data-table/app-data-table'

import { reatomReferralsTable } from '../../atoms'

import type { ClassNameProps } from '@root/shared/react'

type Props = {} & ClassNameProps

export const ReferralsTable: React.FC<Props> = ({ className }) => {
  // eslint-disable-next-line @reatom/unit-naming-rule
  const model = useMemo(() => reatomReferralsTable(), [])

  return (
    <AppDataTable
      className={className}
      css={css`
        height: 100%;
      `}
      model={model}
      rowHeight={40}
    />
  )
}
